import { render, staticRenderFns } from "./indexModel.vue?vue&type=template&id=0d06527e&scoped=true&"
import script from "./indexModel.vue?vue&type=script&lang=js&"
export * from "./indexModel.vue?vue&type=script&lang=js&"
import style0 from "./indexModel.vue?vue&type=style&index=0&id=0d06527e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06527e",
  null
  
)

export default component.exports